import React from 'react'
import './AboutUs.css'

const AboutUs = ({ transporter_data }) => {
    const aboutUs = transporter_data?.about_us ?? 'Details not available'

    return (
        <div className="aucard">
            <div className="aucontainer row">
                <div className="col-12">
                    <h3 className="data_header">Market Intelligence</h3>
                </div>
                <div className="col-12">
                    <p>{aboutUs}</p>
                </div>
            </div>
        </div>
    )
}

export default AboutUs
